<template>
  <el-dialog
      :title="$t('examListCom.FSXQ')"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      center
  >
    <el-form
        :model="form"
    >
      <el-form-item
          :label="$t('examListCom.SSMC')"
      >
        <div style="font-weight: bold">{{form.matchPlanName}}</div>
      </el-form-item>
      <el-form-item
          :label="$t('examListCom.BSLX')"
      >
        <div style="font-weight: bold">{{form.pattern===0? $t('examListCom.TEAM'):$t('examListCom.SINGLE')}}</div>
      </el-form-item>
      <el-form-item
          :label="$t('examListCom.BSJZF')"
      >
        <div style="font-weight: bold">{{form.paperStandScore}}</div>
      </el-form-item>
      <el-form-item
          :label="$t('examListCom.JQPFBF')"
      >
        <div style="font-weight: bold">{{form.machineStandScore}}</div>
      </el-form-item>
      <el-form-item
          :label="$t('examListCom.RGYJBF')"
      >
        <div style="font-weight: bold">{{form.manuStandScore}}</div>
      </el-form-item>
      <el-form-item
          :label="$t('examListCom.DFQK')"
      >
        <div style="color: #bd1a2d;font-weight: bold">{{`${$t('examListCom.ZDF')}${form.paperScore?form.paperScore.toFixed(2):'-'}${$t('examListCom.PQZ')}${form.machineScore?form.machineScore.toFixed(2):'-'}${$t('examListCom.PRG')}${form.manuScore?form.manuScore.toFixed(2):'-'}${$t('examListCom.SCORE')}`}}</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('examListCom.CANCEL')}}</el-button>
      <el-button type="primary" @click="dialogVisible = false">{{$t('examListCom.CONFIRM')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "scoreDetail",
  data () {
    return {
      dialogVisible: false,
      form: {},
    }
  },
  methods: {
    show (val) {
      this.dialogVisible = true
      this.form = val
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog {
  border-radius: 24px;
}
/deep/ .el-form-item {
  height: 30px;
}
/deep/ .el-form-item__label {
  line-height: 30px;
}
/deep/ .el-form-item__content {
  height: 30px;
  line-height: 30px;
}
</style>
